import frMessages from './messages/fr.json';
import hiMessages from './messages/hi.json';
import esMessages from './messages/es-419.json';
import cmnMessages from './messages/zh-cn.json';
import swMessages from './messages/sw.json';
// no need to import en messages-- they are in the defaultMessage field

const messages = {
  fr: frMessages,
  hi: hiMessages,
  'es-419': esMessages,
  sw: swMessages,
  'zh-cn': cmnMessages,
};

export default messages;
